import type { rotinasMenu } from "~/types/pagesMenu";

const TELAS_CONFERENCIA_PLANILHA = ["B311", "B315"] as const;
type TelaConferenciaPlanilha = typeof TELAS_CONFERENCIA_PLANILHA[number];

/**
 * Monta o destino de uma rotina do coletor mantendo seu código na URL.
 * Isso diferencia rotinas que compartilham o mesmo componente de página.
 */
export function criarDestinoRotinaColetor(route: string, tela: rotinasMenu) {
	return {
		path: route,
		query: { tela },
	};
}

/**
 * Resolve se a tela compartilhada foi aberta como B311 ou B315.
 * A URL prevalece sobre o store para funcionar também ao reativar uma página em cache.
 */
export function resolverTelaConferenciaPlanilha(
	telaQuery: string | string[] | null | undefined,
	telaStore: "" | rotinasMenu,
): TelaConferenciaPlanilha {
	const valorQuery = Array.isArray(telaQuery) ? telaQuery[0] : telaQuery;
	if (TELAS_CONFERENCIA_PLANILHA.includes(valorQuery as TelaConferenciaPlanilha)) {
		return valorQuery as TelaConferenciaPlanilha;
	}

	return telaStore === "B315" ? "B315" : "B311";
}
